import {
  GENERATE,
  LOAD,
  SEND,
  load as loadOneTimePasscodes,
} from 'model/oneTimePasscode';
import { selector as pageSettingsSelector } from 'selectors/pageSetting';
import {
  defaultPageSettings,
  pageSettingsName,
} from 'components/modules/service/PayerDetail/OneTimePasscode/config';
import { generate, load, send } from 'sdk/oneTimePasscode';
import { put, select, takeEvery } from 'redux-saga/effects';
import { formatOrderOffsetLimit } from 'util/page';
import { callAction, ORM } from '../util';

export const selectOtpPageSettings = (state, payerId) =>
  pageSettingsSelector(state, payerId, pageSettingsName, defaultPageSettings);

function* sendAndReload(action) {
  const sendOtp = callAction({
    api: send,
    dataName: ORM,
    type: SEND,
  });
  const result = yield sendOtp(action);

  if (result) {
    const { fspId, payerId } = result.props;
    const pageSettings = yield select(selectOtpPageSettings, payerId);
    const { order, orderBy, page, rowsPerPage, userId } = pageSettings;

    yield put(
      loadOneTimePasscodes({
        ...formatOrderOffsetLimit({ order, orderBy, page, rowsPerPage }),
        ...(userId ? { userId } : {}),
        fspId,
        payerId,
      })
    );
  }
}

export default function* saga() {
  yield takeEvery(
    GENERATE.ACTION,
    callAction({
      api: generate,
      dataName: ORM,
      type: GENERATE,
    })
  );

  yield takeEvery(SEND.ACTION, sendAndReload);

  yield takeEvery(
    LOAD.ACTION,
    callAction({
      api: load,
      dataName: ORM,
      type: LOAD,
    })
  );
}
